import React, { useCallback, useState, useMemo } from "react";
import { Button, Select } from "@activecollab/components";
import PropTypes from "prop-types";
import { editableBillableStatusOptions } from "~/utils/tracking.jsx";

export const BillableStatusPicker = ({ selected, onChange, className, canMarkAsPaid }) => {
  const [active, setActive] = useState(false);
  const options = canMarkAsPaid ? editableBillableStatusOptions : editableBillableStatusOptions.slice(0, 2);

  const handleOpen = useCallback(() => {
    setActive(true);
  }, []);

  const handleClose = useCallback(() => {
    setActive(false);
  }, []);

  const selectedName = useMemo(() => {
    const result = options.find(({ id }) => id === selected)?.name;
    return result ?? options[0].name;
  }, [selected, options]);

  const handleChange = useCallback(
    (id) => {
      typeof onChange === "function" && onChange({ billable_status: id });
    },
    [onChange]
  );

  return (
    <Select
      target={
        <Button
          className={className}
          variant="text gray"
          active={active}
        >
          {selectedName}
        </Button>
      }
      disableSearch
      onSelectOpen={handleOpen}
      onSelectClose={handleClose}
      selected={selected}
      options={options}
      onChange={handleChange}
      forceCloseMenu
      disabledInternalSort
      keepSameOptionsOrder
    />
  );
};

BillableStatusPicker.propTypes = {
  selected: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  canMarkAsPaid: PropTypes.bool,
};

BillableStatusPicker.defaultProps = {
  canMarkAsPaid: false,
};
